// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2787e5dfdf--wrapper--d0Kt_"};